import { connect } from 'react-redux'
import React, { useEffect } from 'react'
import {
  Btn,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomDropdown,
  CustomModal,
  InputText,
  SectionTitle,
} from '../../../../../components'
import { hideLoadingBox, showMessageBox } from '../../../../../store/actions/system.actions'
import useModalMotivoAtraso, { LOAD_MESSAGE, TYPES } from './ModalMotivoAtrasoHook'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../../assets/js/styles'
import { getTps } from '../../../../../services/localstorage/localstorage.service'

function ModalMotivoAtraso({ dispatch, selectedTp, show, data, onModalClose, onModalSave }) {
  const { state, localDispatch } = useModalMotivoAtraso()

  const tps = getTps(false).map(tp => ({ selected: false, ...tp }))

  useEffect(() => {
    if (show) localDispatch.onInit(data, tps)
  }, [show])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.EDIT_MOTIVO:
        dispatch(hideLoadingBox())
        localDispatch.updateMotivoAtraso(
          state.motivoAtraso,
          state.tps.filter(tp => tp.selected),
        )
        break

      case LOAD_MESSAGE.SAVE_MOTIVO:
        dispatch(hideLoadingBox())
        localDispatch.saveMotivoAtraso(
          state.motivoAtraso,
          state.tps.filter(tp => tp.selected),
        )
        break

      case LOAD_MESSAGE.SAVE_MOTIVO_SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        onModalSave(state.updatedMotivo, selectedTp)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <CustomModal
      header={`${state.motivoAtraso.id === 0 ? 'Novo' : 'Editando'} Motivo de Atraso`}
      isVisible={show}
      onClose={onModalClose}
      width={600}
    >
      <form className="p-grid p-align-center" onSubmit={e => e.preventDefault()}>
        <div className="p-col-12">
          <InputText
            marginTop={0}
            label="Motivo de Atraso"
            value={state.motivoAtraso.name}
            onChange={value => localDispatch.onFieldChange('name', value)}
          />
        </div>
        <div className="p-col-3">
          <CustomDropdown
            label={'Tipo de Motivo'}
            value={state.motivoAtraso.type}
            options={TYPES}
            onChange={value => localDispatch.onFieldChange('type', value)}
          />
        </div>
        <div className="p-col-12">
          <SectionTitle title={'Operações que terão acesso ao Motivo de Atraso:'} />
        </div>
        <div className="p-col-12">
          <CustomCheckbox
            checked={state.selecionarTodos}
            onChange={() => localDispatch.onChangeSelecionarTodos(!state.selecionarTodos)}
          >
            Selecionar Todos
          </CustomCheckbox>
        </div>
        <div className="p-col-12">
          <DataTable
            value={state.tps}
            paginator={true}
            rows={3}
            header={<CustomDataTableHeader onChange={localDispatch.onChangeGlobalFilter} />}
            globalFilter={state.globalFilter}
          >
            <Column
              header={'#'}
              body={tp => (
                <CustomCheckbox
                  checked={tp.selected}
                  onChange={() => localDispatch.onCheckboxChange(tp)}
                />
              )}
              style={tableCellCentered(80)}
            />
            <Column field={'name'} header={'Operação Logística'} />
          </DataTable>
        </div>
        <div className="p-col-2 p-col-align-end" style={{ paddingTop: 0 }}>
          <Btn onClick={() => localDispatch.onBtnSalvarClicked(state.motivoAtraso, state.tps)}>
            Salvar
          </Btn>
        </div>
      </form>
    </CustomModal>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(ModalMotivoAtraso)
